import { LuArrowLeft, LuSettings, LuUpload } from "react-icons/lu";
const icons = { arrowBack: LuArrowLeft, gear: LuSettings, upload: LuUpload };
/** Same Lucide controls as the native app; branded logos remain image assets. */
export default function AppIcon({ name, alt, className = "", ...props }) {
  const Icon = icons[name];
  if (!Icon) return null;
  return (
    <Icon
      size={22}
      strokeWidth={2}
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      className={className.replace(
        /\b(?:grayscale|brightness-0|dark:invert)\b/g,
        "",
      )}
      {...props}
    />
  );
}
